import React, { PureComponent } from 'react';
import moment from 'moment';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { withRouter } from 'react-router-dom';
import { Col, Row } from 'elements';

import * as ROUTES from 'config/routes';
import GridCards from './components/grid-cards';
import ZoneFilter from './components/zone-filter';
import ListView from './components/list-view';
import FilterBar from './components/filter-bar'
import { holdersSelector, userSelector, operatorSiteDetailsSelector, operatorSiteDetailsStatusSelector, zonesCheckinCheckoutInfoSelector } from 'redux/selectors'
import SecurityMessaging from './components/security-messaging';
import {
	listSites,
	listZones,
	listenToSubscriptions,
	listCheckinCheckoutZones
} from 'redux/modules/model/site';
import { getOperatorSite } from 'redux/modules/model/operator'
import { liveViewEnabledRedir } from 'hocs/auth';
import { PageContainer } from 'smart-components';
import { PageContent } from 'components';
import { parseQueryString, jsonToQueryString } from 'utils/helpers';
import { liveDiscoverySelector } from 'redux/selectors';
import { listHolders } from 'redux/modules/model/holder'
import { userIsAuthenticatedRedir } from 'hocs/auth';
import { withClientId } from 'hocs';
import { ZONE_ENTITIES_VALIDATE_INTERVAL } from 'config/constants';
import * as actions from '@/redux/new_store_structure/actions';
import { wsClient } from '@/index';
import EvacuationButton from '@/pages/evacuation-demo/components/evacuation-button';

class LiveEvacuation extends PureComponent {
	constructor(props) {
		super(props);

		this.state = {
			queryParams: {
				view: 'large',
				...parseQueryString(this.props.location.search),
			},
			siteId: null,
			zoneId: null,
			allSitesList: [],
			showZoneItems: false,
			isEvacuationStarted: false,
			type: 'evacuation',
			evacuationStartTime: null,
			currentTime: new Date(),
		};
	}

	componentDidMount() {
		const { getSitesList, clientId, listHolders, user, getOperatorSite, listCheckinCheckoutZones } = this.props;
		const operator = user && user.currentUser && user.currentUser.operator
		getSitesList({ clientId });
		listCheckinCheckoutZones({ clientId })
		getOperatorSite({ clientId, username: operator.username });
		const activeFilter = { active: true }
		listHolders({ clientId, filter: activeFilter, with: 'metadata' })
		this.timerId = window.setInterval(
			this.props.clearInactiveEntities,
			ZONE_ENTITIES_VALIDATE_INTERVAL,
		);
	}
	componentDidUpdate(prevProps, prevState) {
		const { siteId, zoneId } = this.state;
		const { sitesList, clientId, getZonesList, zonesList, discoveredList, user } = this.props;
		console.log("zonesList:", zonesList)
		const operator = user && user.currentUser && user.currentUser.operator
		let defaultSite = operator.default_site
		this.setState({ allSitesList: discoveredList })
		if (siteId === "null" || clientId === 'unifiid-demo' || clientId === 'tsb' || clientId === 'test-club') {
			prevProps.discoveredList.forEach(record => {
				discoveredList.forEach((newRecord, i) => {
					if (record.clientReference === newRecord.clientReference) {
						if (record.detectionTime > newRecord.detectionTime) {
							var item = {
								detectionTime: record.detectionTime,
								clientReference: record.clientReference,
								siteId: record.siteId,
								zoneId: record.zoneId
							}
							discoveredList[i] = item
							this.setState({ allSitesList: discoveredList })
						}
					}
				})
			})
			this.state.allSitesList.forEach(record => {
				discoveredList.forEach((newRecord, i) => {
					if (record.clientReference === newRecord.clientReference) {
						if (record.detectionTime > newRecord.detectionTime) {
							var item = {
								detectionTime: record.detectionTime,
								clientReference: record.clientReference,
								siteId: record.siteId,
								zoneId: record.zoneId
							}
							discoveredList[i] = item
							this.setState({ allSitesList: discoveredList })
						}
					}
				})
			})
		}

		if (siteId && prevState.siteId !== siteId) {
			getZonesList({ clientId, siteId });
			this.subscribe();
			this.setShowZoneItems();
		}
		if (sitesList && sitesList.length > 0 && !siteId) {
			if (defaultSite) {
				this.handleSiteChange(defaultSite);
			} else {
				this.handleSiteChange(sitesList[0].siteId);
			}
		}
		if (zonesList && zonesList.length > 0 && !zoneId && siteId) {
			const newZone =
				zonesList && zonesList.length === 1
					? zonesList[0].zoneId
					: 'null';
			this.handleZoneChange(newZone);
		}
	}

	componentWillUnmount() {
		this.timerId && window.clearInterval(this.timerId);
		this.unsubscribe();
	}

	fetchStopEvacuation = () => {
		// const { activeSiteId } = state;
		// const { clientId } = props;
		// if (activeSiteId === null) return;
		clearInterval(this.clockInterval);

		this.setState({
			isEvacuationStarted: false,
			evacuationStartTime: null,
		});

		// const requestPayload = {
		// 	messageType: 'evacuation.evacuation.end-evacuation',
		// 	payload: {
		// 		clientId,
		// 		siteId: activeSiteId,
		// 	},
		// };

		// wsClient.request(requestPayload, () => {
		// 	getEvacuation();
		// });
	};

	// fetchStartEvacuation = () => {
	// 	const { activeSiteId } = this.state;
	// 	const { clientId } = this.props;
	// 	if (activeSiteId === null) return;
	// 	// const requestPayload = {
	// 	// 	messageType: 'evacuation.evacuation.start-evacuation',
	// 	// 	payload: {
	// 	// 		clientId,
	// 	// 		siteId: activeSiteId,
	// 	// 	},
	// 	// };

	// 	// wsClient.request(requestPayload, () => {
	// 	// 	getEvacuation();
	// 	// });
	// };
	fetchStartEvacuation = async () => {
		// Prevent double start
		if (this.state.isEvacuationStarted) return;

		const startTime = new Date();

		try {
			// Optional: call backend
			// await api.startEvacuation();

			this.setState({
				isEvacuationStarted: true,
				evacuationStartTime: startTime,
			});

			// Start ticking current time
			this.clockInterval = setInterval(() => {
				this.setState({ currentTime: new Date() });
			}, 1000);

		} catch (error) {
			console.error('Failed to start evacuation', error);
		}
	};
	toggleEvacuation = () => {
		const { isEvacuationStarted, type } = this.state;
		// if (type === 'replay') {
		// 	// cut of unnecessary props
		// 	const { activeSiteId, sitesList, ...resetState } = initialState;
		// 	dispatch({
		// 		type: 'setState',
		// 		payload: {
		// 			...resetState,
		// 		},
		// 	});
		// 	return;
		// }
		if (isEvacuationStarted) {
			this.fetchStopEvacuation();
		} else {
			this.fetchStartEvacuation();
		}
	};

	setShowZoneItems = () => this.setState({ showZoneItems: true });

	setURLHref(params) {
		const { history } = this.props;
		history.push({
			location: ROUTES.LIVE_VIEW_DIRECTORY,
			search: jsonToQueryString(params),
		});
	}

	handleFilterChange = value => {
		const { filters, grouping, view, search } = this.state.queryParams;
		let newFilters = filters;

		const key = Object.keys(value)[0];
		const position = filters.indexOf(key);
		if (value[key] && position === -1) {
			newFilters.push(key);
		}

		if (!value[key] && position !== -1) {
			newFilters = [
				...filters.slice(0, position),
				...filters.slice(position + 1),
			];
		}

		this.setURLHref({
			filters: newFilters,
			grouping,
			view,
			search,
		});
	};

	handleViewModeChange = view => {
		this.setURLHref({
			...this.state.queryParams,
			view,
		});
	};

	handleSearch = search => {
		this.setURLHref({
			...this.state.queryParams,
			search: encodeURIComponent(search),
		});
	};

	handleSearchChange = e => {
		this.setState({
			search: e.target.value,
		});
		const params = {
			...parseQueryString(location.search),
			search: e.target.value,
		};
		this.setURLHref(params);
	};

	handleSiteChange = siteId => {
		const newQueryStr = {
			...this.state.queryParams,
			site: encodeURIComponent(siteId),
			zone: 'null',
			search: this.state.search
		};
		this.setURLHref(newQueryStr);
		this.setState({ queryParams: newQueryStr, siteId });
	};

	handleZoneChange = zoneId => {
		const newQueryStr = {
			...this.state.queryParams,
			zone: encodeURIComponent(zoneId),
			search: this.state.search
		};
		this.setURLHref(newQueryStr);
		this.setState({ queryParams: newQueryStr, zoneId });
	};

	subscribe = () => {
		const { siteId } = this.state;
		const {
			listenToSubscriptions,
			clientId,
			verticalConfig,
			sitesList
		} = this.props;
		const enabledVerticals = Object.keys(verticalConfig);
		if (clientId === 'unifiid-demo' || clientId === 'tsb' || clientId === 'test-club') {
			sitesList.forEach(site => {
				const currentSite = site.siteId
				listenToSubscriptions({
					clientId,
					siteId: currentSite,
					includeLastKnown: true, // cutoff = Instant.now().minus(LAST_KNOWN_DETECTIONS_CUTOFF); LAST_KNOWN_DETECTIONS_CUTOFF = Duration.ofDays(1);
				});
			})
		} else {
			if (siteId === 'null') {
				sitesList.forEach(site => {
					const currentSite = site.siteId
					listenToSubscriptions({
						clientId,
						siteId: currentSite,
						includeLastKnown: true, // cutoff = Instant.now().minus(LAST_KNOWN_DETECTIONS_CUTOFF); LAST_KNOWN_DETECTIONS_CUTOFF = Duration.ofDays(1);
					});
				})
			} else {
				listenToSubscriptions({
					clientId,
					siteId,
					includeLastKnown: true, // cutoff = Instant.now().minus(LAST_KNOWN_DETECTIONS_CUTOFF); LAST_KNOWN_DETECTIONS_CUTOFF = Duration.ofDays(1);
				});
			}
		}
	};
	unsubscribe = () => {
		wsClient.clearAllCorrelations('core.site.subscribe-detections');
	};

	getDetectionClass = (detectionTime, evacuationStartTime, zoneId, zones) => {
		if (!evacuationStartTime || !detectionTime) return '';

		const zone = zones.find(z => z.zoneId === zoneId);

		const detection = new Date(detectionTime);
		const evacuationStart = new Date(evacuationStartTime);

		const diffMinutes =
			(evacuationStart - detection) / (1000 * 60);

		if (diffMinutes <= 0)
			if (zone) {
				if (zone.description === 'enter') return 'zone-enter';
				if (zone.description === 'exit') return 'zone-exit';
			}
		if (diffMinutes <= 60) return 'detected-before-60-yellow';

		return 'detected-before-60-plus-red';
	};
	render() {
		const {
			queryParams: { zone: zoneId, site: siteId },
		} = this.state;
		const { allSitesList, type, isEvacuationStarted, currentTime, evacuationStartTime } = this.state;
		console.log("LiveEvacuation state:", this.state);
		console.log("type:", type);
		const params = parseQueryString(location.search)
		let search = params.search

		const {
			zonesList: zones,
			sitesList: sites,
			verticalConfig,
			holdersList,
			operatorSite,
			clientId,
			zonesCheckinCheckoutInfo,
			user
		} = this.props;
		console.log("LiveEvacuation props:", this.props);
		// let filteredSites = []
		if (operatorSite) {
			if (operatorSite.length > 0) {
				const operatorSites = [];
				operatorSite.forEach(operator => {
					operatorSites.push(operator.siteId)
				})
				sites.forEach((site, i) => {
					if (!operatorSites.includes(site.siteId)) {
						sites.splice(i, 1)
					}
				})
				// filteredSites = sites.filter((site) => operatorSites.includes(site.siteId));
			}
		}
		let clientReferencesList = []
		holdersList.forEach((holder, i) => {
			if (holder.name.toUpperCase().includes((search || "").toUpperCase()) || !search) {
				clientReferencesList.push(holder.clientReference)
			}
		})
		console.log("clientReferencesList:", clientReferencesList)
		console.log("holdersList:", holdersList)
		// let timeFilteredList = allSitesList
		// console.log("allSitesList:", allSitesList)
		// let zoneFilteredList = timeFilteredList
		let timeFilteredList = allSitesList

		let zoneFilteredList = timeFilteredList
		var d = new Date();
		d.setHours(0, 0, 0, 0);
		if (isEvacuationStarted) {
			timeFilteredList = allSitesList.filter(
				detection => new Date(detection.detectionTime) > d
			)
			let checkinSites = []
			let checkinZones = []
			zonesCheckinCheckoutInfo.forEach(zoneCheckinCheckout => {
				if (zoneCheckinCheckout.checkin) {
					checkinSites.push(zoneCheckinCheckout.siteId)
					checkinZones.push(zoneCheckinCheckout.zoneId)
				}
			})
			console.log("checkinSites:", checkinSites)
			console.log("checkinZones:", checkinZones)

			zoneFilteredList = timeFilteredList.filter(
				detection => checkinSites.includes(detection.siteId) && checkinZones.includes(detection.zoneId)
			);
			console.log("zoneFilteredList:", zoneFilteredList)
		}
		console.log("timeFilteredList:", timeFilteredList)

		let newDiscoveredList = zoneFilteredList.filter(
			el => clientReferencesList.indexOf(el.clientReference) !== -1
		);
		console.log("newDiscoveredList:", newDiscoveredList)

		const discoveredMap = new Map(
			newDiscoveredList.map((item) => [item.clientReference, item])
		);

		let filteredBySite = newDiscoveredList
		if (siteId !== "null")
			filteredBySite = newDiscoveredList.filter(
				el => el.siteId === siteId,
			);
		const zoneItems =
			zoneId && zoneId !== 'null'
				? filteredBySite
					.filter(item => {
						return item.zoneId ? item.zoneId === zoneId : false;
					})
					// Sort by reverse chronological order
					.sort(
						(item1, item2) =>
							moment(item2.detectionTime).unix() -
							moment(item1.detectionTime).unix(),
					)
				: filteredBySite.sort(
					(item1, item2) =>
						moment(item2.detectionTime).unix() -
						moment(item1.detectionTime).unix(),
				);
		console.log("zoneItems:", zoneItems)
		const holderMap = holdersList.reduce((acc, holder) => {
			acc[holder.clientReference] = holder.name;
			return acc;
		}, {});
		const zoneItemsWithNames = zoneItems.map(item => ({
			...item,
			name: holderMap[item.clientReference] || null
		}));
		console.log("zoneItemsWithNames:", zoneItemsWithNames)
		const zoneItemsWithNamesAndClasses = zoneItemsWithNames.map(item => ({
			...item,
			classObj: this.getDetectionClass(
				item.detectionTime,
				this.state.evacuationStartTime,
				item.zoneId,
				zones
			),
		}));
		console.log("zoneItemsWithNamesAndClasses:", zoneItemsWithNamesAndClasses)
		return (
			<PageContainer>
				<PageContent className={'no-btm-padding'}>
					<PageContent.Main>
						<div className="live-view">
							<Row gutter={16}>
								<Col md={12}>
									<ZoneFilter
										onZoneChange={this.handleSiteChange}
										zoneId={siteId}
										zones={sites}
										placeholder="Select a site"
										idKey="siteId"
										nameKey="description"
										optAll={{
											label: 'All sites',
											value: 'null',
										}}
									/>

								</Col>
								<Col md={12}>
									<FilterBar setURLHref={this.setURLHref} onSearchChange={this.handleSearchChange} />
								</Col>
								<Col md={4} xs={24}>
									<EvacuationButton
										style={{
											background: '#5a92c9',
											border: '#5a92c9',
										}}
										isActive={isEvacuationStarted}
										toggleClick={this.toggleEvacuation}
										type={type}
									/>
									{isEvacuationStarted && (
										<div style={{ marginTop: 12 }}>
											<div>
												<strong>Evacuation started:</strong>{' '}
												{evacuationStartTime.toLocaleTimeString()}
											</div>
											<div>
												<strong>Current time:</strong>{' '}
												{currentTime.toLocaleTimeString()}
											</div>
										</div>
									)}
								</Col>
							</Row>
							<Row gutter={40} align="middle" justify="center" className="row-counters">
								<Col xs={12} md={7}>
									<button className="unifi-button-counter">
										Total: {timeFilteredList.length}
									</button>
								</Col>
								<Col xs={20} md={9}>
									<button className="unifi-button-counter">
										In: {zoneItemsWithNames.length}
									</button>
								</Col>
								<Col xs={14} md={8}>
									<button className="unifi-button-counter">
										Out: {timeFilteredList.length - zoneItemsWithNames.length}
									</button>
								</Col>
							</Row>
							<ListView
								// loading={loading}
								holders={zoneItemsWithNamesAndClasses}
							// onTableChange={this.handleTableChanges}
							// onPageChange={this.handleViewModeChange}
							// page={page}
							// perPage={perPage}
							// sorter={sorter}
							// order={order}
							/>
						</div>
					</PageContent.Main>
				</PageContent>
			</PageContainer>
		);
	}
}

export const selector = createStructuredSelector({
	discoveredList: liveDiscoverySelector,
	sitesList: ({ sites }) => sites.list,
	zonesList: ({ sites }) => sites.zonesList,
	verticalConfig: ({ user: { currentUser } }) => currentUser.verticalConfig,
	holdersList: holdersSelector,
	user: userSelector,
	operatorSite: operatorSiteDetailsSelector,
	operatorSiteDetailsStatus: operatorSiteDetailsStatusSelector,
	zonesCheckinCheckoutInfo: zonesCheckinCheckoutInfoSelector
});

export const mapDispatchToProps = dispatch => ({
	listSites: params => dispatch(listSites(params)),
	listZones: params => dispatch(listZones(params)),
	listenToSubscriptions: params => dispatch(listenToSubscriptions(params)),
	getSitesList: params => dispatch(actions.getSitesList(params)),
	getZonesList: params => dispatch(actions.getSitesZonesList(params)),
	listHolders: params => dispatch(listHolders(params)),
	getOperatorSite: params => dispatch(getOperatorSite(params)),
	listCheckinCheckoutZones: params => dispatch(listCheckinCheckoutZones(params))
});

export default compose(
	userIsAuthenticatedRedir,
	liveViewEnabledRedir,
	withRouter,
	withClientId,
	connect(selector, mapDispatchToProps),
)(LiveEvacuation);


// WEBPACK FOOTER //
// ./src/pages/live-evacuation/index.js